import React from "react";
import { Row, Col } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  SiVercel,
  SiNetlify,
} from "react-icons/si";

const tools = [
  { icon: <SiVisualstudiocode />, name: "VS Code" },
  { icon: <SiPostman />, name: "Postman" },
  { icon: <SiVercel />, name: "Vercel" },
  { icon: <SiNetlify />, name: "Netlify" },
];

const Toolstack = () => {
  return (
    <Row
      style={{
        justifyContent: "center",
        paddingBottom: "50px",
      }}
    >
      {tools.map((tool, index) => (
        <Col key={index} xs={4} md={2} className="tech-icons" title={tool.name}>
          <div className="tech-icon">{tool.icon}</div>
          <span className="tech-name">{tool.name}</span>
        </Col>
      ))}
    </Row>
  );
};

export default Toolstack;
